package com.stevdza.san.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*

@OptIn(ExperimentalComposeWebApi::class)
val AboutImageStyle = CssStyle {
    base {
        return@base Modifier
            .styleModifier {
//                filter { grayscale(100.percent) }
                property("transition", "all 200ms")
            }
            .borderRadius(r = 25.px)
            .rotate(0.deg)
    }
    hover {
        return@hover Modifier
            .styleModifier { filter { grayscale(0.percent) } }
            .borderRadius(r = 100.px)
            .rotate(6.deg)
    }
}

val AboutTextStyle = CssStyle {
    base {
        return@base Modifier
            .fontSize(16.px)
//            .opacity(50.percent)
            .styleModifier { property("transition", "opacity 200ms") }
    }
    hover {
        return@hover Modifier.opacity(100.percent)
    }
}
